export const coOrdinatorId = [
    "b6c923fa-1432-4bc7-b56a-5f93ef37c118",  // production isha
    // "7c720f1a-b79d-4244-b192-34e86f7e6fb6"  // local
]

export const adminId = [
    "9d66df3a-17ae-46f6-8cef-05b62d34b3b9",  // production Vedant
    // "46cbd712-5e3b-4d19-8ad9-6b580fb0aebf"  // local
]

export const songDuration = [
    "40 seconds",
    "1.0 minute",
    "1.5 minutes",
    "2.0 minutes",
    "2.5 minutes",
    "3.0 minutes",
    "3.5 minutes",
]
